/**
 * Created by pandemio on 4/2/19.
 */
import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, Row, Col } from 'reactstrap';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/
import PlansDataTable from '../datatables/plan-data-table';

/**
 * Model that handles the clients
 */
class ModalPlanSelection extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            visible: props.visible
        };

        this.toggle = this.toggle.bind(this);
        this.handleSelected = this.handleSelected.bind(this);
    }

    /**
     * Hide or shows the window
     */
    toggle() {
        this.setState({
            visible: !this.state.visible
        },()=>{
            this.props.updateParent(null);
        });
    }

    handleSelected(e){
        this.props.updateParent(e);
    }

    render() {
        return (
            <div>
                <Modal isOpen={this.state.visible} toggle={this.toggle} className="modal-results">
                    <ModalHeader toggle={this.toggle}>
                        <Translate id="plan.plan-search"/>
                        <br/>
                        <small>
                            <Translate id="plan.plan-search-selection-instructions"/>
                        </small>
                    </ModalHeader>
                    <ModalBody>
                        <Row>
                            <Col lg={{size: 12}} md={{size: 12}} sm={{size: 12}} xs={{size: 12}}>
                                <PlansDataTable updateParent={this.handleSelected}/>
                            </Col>
                        </Row>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}
export default ModalPlanSelection;